import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {StateInterface} from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  constructor(
    private http: HttpClient,
  ) {
  }

  private headers = {
    headers: new HttpHeaders({
        'X-CSCAPI-KEY': 'dThkWGR4bGRoQlRRUzFuc3Joako2QXFidktRMnhYcWJMMWFHTThpOQ==',
      }
    )
  };


  public getStatesByCountryCode(code: string): Observable<StateInterface[]> {
    return this.http.get<StateInterface[]>(`https://api.countrystatecity.in/v1/countries/${code}/states`, this.headers);
  }

  public getCitiesByStateCounties(CountryCode: string, cityCode): Observable<{ name: string, id: number }[]> {
    return this.http.get<{ name: string, id: number }[]>(`https://api.countrystatecity.in/v1/countries/${CountryCode}/states/${cityCode}/cities`, this.headers);
  }

  public getCounties(): Observable<StateInterface[]> {
    return this.http.get<StateInterface[]>(`https://api.countrystatecity.in/v1/countries`, this.headers);
  }

}
